export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $('.nav-container').addClass('closed');
    $('.burgerlink').click(function openMenu() { $('.nav-container').toggleClass('closed'); });
//    $('.burgerlink').click(function closeMenu() { $('.nav-container').addClass('closed').addClass('fuffi'); });
    $('.final-tiles-gallery').finalTilesGallery({
      margin: 10,
      gridSize: 13,
      imageSizeFactor:	[[4000, 0.7],[1024, 0.6],[800, 0.5],[600, 0.4],[480, 0.3]],
//		  layout: 'columns',
//		  gridSize: 0
    });
    $('.fancybox').fancybox({
      tpl: {
        error:'<p class="fancybox-error">Das Laden des Inhalts hat nicht geklappt.<br />Bitte später nochmals versuchen.</p>',
        closeBtn:'<div title="Schließen" class="fancybox-item fancybox-close"></div>',
        next:'<a title="Weiter" class="fancybox-nav fancybox-next"><span></span></a>',
        prev:'<a title="Zurück" class="fancybox-nav fancybox-prev"><span></span></a>',
      },
      prevEffect: 'none',
      nextEffect: 'none',
      helpers: {
        title: {
          type: 'outside',
        },
        overlay: {
          speedIn: 420,
          opacity: 0.8,
          locked: false,
        },
        thumbs: {
          width: 50,
          height: 50,
        },
     },
     padding: 0,
     margin: 21,
    });
  },
  };



// WEBPACK FOOTER //
// ./scripts/routes/common.js